import { faUndo, faFilePdf, faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { authActions } from '../_actions';
import Select from 'react-select';
import { withRouter } from '../_helpers/withRouter';
import {
    Button, Card, CardBody, CardHeader,
    Col, Container, Form, FormGroup, Input, Label, Row,
} from 'reactstrap';
import Swal from 'sweetalert2';
import { relatorioAction, empresaAction, usuarioAction, produtorAction, prefeituraAction } from '../_actions';
import NavBar from '../_components/navbar';
import '././styles.css';
import './styles.css';

const RelatorioFiltro = (props) => {

    const dispatch = useDispatch();
    const { match: { params } } = props;

    const [, forceUpdate] = React.useState(0);

    const handleChange = prop => event => {
        const { dispatch } = props;
        dispatch(relatorioAction.onChangeProps(prop, event));
    };

    useEffect(() => {
        if (authActions.isPrefeitura()) {
            dispatch(empresaAction.getEmpresasSelect());
            dispatch(usuarioAction.getSelectInseminadores());
            dispatch(produtorAction.getSelectProdutoresByPrefeitura(true));
        }
        if (authActions.isInseminador()) {
            dispatch(prefeituraAction.getPrefeiturasSelect());
            dispatch(produtorAction.getSelectProdutoresByPrefeitura(true));
        }
        if (authActions.isGestor()) {
            dispatch(prefeituraAction.getPrefeiturasSelect());
            dispatch(empresaAction.getEmpresasSelect());
            dispatch(usuarioAction.getSelectInseminadores());
            dispatch(produtorAction.getSelectProdutoresByPrefeitura(true));
        }
    }, [])

    const handleSelectChange = prop => event => {
        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };

        dispatch(relatorioAction.onChangeProps(prop, event2));
    };

    const handleValidation = event => {

        var valid = true;
        var errors = '';

        if (props.relatorio.data_inicio === null || props.relatorio.data_inicio === '') {
            valid = false;
            errors += '<li style="float:left;">Informe uma data de início!</li><br>';
        }
        if (props.relatorio.data_termino === null || props.relatorio.data_termino === '') {
            valid = false;
            errors += '<li style="float:left;">Informe uma data de fim!</li><br>';
        }
        if (props.relatorio.data_termino != null && props.relatorio.data_inicio != null) {
            if (props.relatorio.data_termino < props.relatorio.data_inicio) {
                valid = false;
                errors += '<li style="float:left;">Data de término não pode ser menor que a data de início!</li><br>';
            }
        }
        if (authActions.isInseminador() || authActions.isGestor()) {
            if (props.relatorio.inscricao_prefeitura === null || props.relatorio.inscricao_prefeitura === '') {
                valid = false;
                errors += '<li style="float:left;">Informe uma prefeitura!</li><br>';
            }
        }

        if (!valid) {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });
        }
        return valid;
    };

    const renderOptionsEmpresas = () => {
        const { match: { params } } = props;
        return props.empresa.empresa.map((p, i) => {
            return (
                {
                    value: p.Value, label: p.Text,
                }
            );
        });
    };

    const renderOptionsInseminador = () => {
        return props.usuario.usuario.map((p, i) => {
            return (
                { value: p.Value, label: p.Text }
            );
        });
    };

    const renderOptionsProdutores = () => {
        const { match: { params } } = props;
        return props.produtor.produtor.map((p, i) => {
            return (
                {
                    value: p.Value, label: p.Text,
                }
            );
        });
    };

    const renderOptionsPrefeituras = () => {
        const { match: { params } } = props;
        return props.prefeitura.prefeitura.map((p, i) => {
            return (
                {
                    value: p.Value, label: p.Text,
                }
            );
        });
    };

    const handleGerarRelatorio = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            if (authActions.isPrefeitura()) {
                let payload = {
                    tipo_relatorio: "R",
                    inscricao_prefeitura: props.authentication.user.Prefeitura.inscricao_estadual,  //pega a prefeitura da prefeitura logada
                    id_inseminador: props.relatorio.id_inseminador ? props.relatorio.id_inseminador : 0,
                    data_inicio: props.relatorio.data_inicio,
                    data_termino: props.relatorio.data_termino,
                    id_empresa: props.relatorio.id_empresa ? props.relatorio.id_empresa : 0,
                    id_produtor: props.relatorio.id_produtor ? props.relatorio.id_produtor : 0
                };

                //  console.log("payload", payload);
                dispatch(relatorioAction.getRelatorio(payload, true));
            }
            else if (authActions.isInseminador()) {
                let payload = {
                    tipo_relatorio: "R",
                    inscricao_prefeitura: props.relatorio.inscricao_prefeitura,
                    id_inseminador: props.authentication.user.id,  // pega o id do inseminador logado
                    data_inicio: props.relatorio.data_inicio,
                    data_termino: props.relatorio.data_termino,
                    id_empresa: props.authentication.user.Empresa.id,  //pega a empresa do inseminador logado
                    id_produtor: props.relatorio.id_produtor ? props.relatorio.id_produtor : 0
                };

                //   console.log("payload", payload);
                dispatch(relatorioAction.getRelatorio(payload, true));
            }
            else if (authActions.isGestor()) {
                let payload = {
                    tipo_relatorio: "R",
                    inscricao_prefeitura: props.relatorio.inscricao_prefeitura,
                    id_inseminador: props.relatorio.id_inseminador ? props.relatorio.id_inseminador : 0,
                    data_inicio: props.relatorio.data_inicio,
                    data_termino: props.relatorio.data_termino,
                    id_empresa: props.relatorio.id_empresa ? props.relatorio.id_empresa : 0,
                    id_produtor: props.relatorio.id_produtor ? props.relatorio.id_produtor : 0
                };

                //  console.log("payload", payload);
                dispatch(relatorioAction.getRelatorio(payload, true));
            }
        }
    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            if (authActions.isPrefeitura()) {
                let payload = {
                    tipo_relatorio: "C",
                    inscricao_prefeitura: props.authentication.user.Prefeitura.inscricao_estadual,  //pega a prefeitura da prefeitura logada
                    id_inseminador: props.relatorio.id_inseminador ? props.relatorio.id_inseminador : 0,
                    data_inicio: props.relatorio.data_inicio,
                    data_termino: props.relatorio.data_termino,
                    id_empresa: props.relatorio.id_empresa ? props.relatorio.id_empresa : 0,
                    id_produtor: props.relatorio.id_produtor ? props.relatorio.id_produtor : 0
                };

                //  console.log("payload", payload);
                dispatch(relatorioAction.getComprovante(payload, true));
            }
            else if (authActions.isInseminador()) {
                let payload = {
                    tipo_relatorio: "C",
                    inscricao_prefeitura: props.relatorio.inscricao_prefeitura,
                    id_inseminador: props.authentication.user.id,  // pega o id do inseminador logado
                    data_inicio: props.relatorio.data_inicio,
                    data_termino: props.relatorio.data_termino,
                    id_empresa: props.authentication.user.Empresa.id,  //pega a empresa do inseminador logado
                    id_produtor: props.relatorio.id_produtor ? props.relatorio.id_produtor : 0
                };

                //  console.log("payload", payload);
                dispatch(relatorioAction.getComprovante(payload, true));
            }
            else if (authActions.isGestor()) {
                let payload = {
                    tipo_relatorio: "C",
                    inscricao_prefeitura: props.relatorio.inscricao_prefeitura,
                    id_inseminador: props.relatorio.id_inseminador ? props.relatorio.id_inseminador : 0,
                    data_inicio: props.relatorio.data_inicio,
                    data_termino: props.relatorio.data_termino,
                    id_empresa: props.relatorio.id_empresa ? props.relatorio.id_empresa : 0,
                    id_produtor: props.relatorio.id_produtor ? props.relatorio.id_produtor : 0
                };

                // console.log("payload", payload);
                dispatch(relatorioAction.getComprovante(payload, true));
            }
        }
    };

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <h5>Gerar Relatório de Inseminações</h5>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={4} lg={4}>
                                    <FormGroup>
                                        <Label className="left" for="data_inicio">Data início *</Label>
                                        <Input
                                            id="data_inicio"
                                            label="Data início *"
                                            className="form-control"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={props.relatorio.data_inicio}
                                            onChange={handleChange('data_inicio')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={4} lg={4}>
                                    <FormGroup>
                                        <Label className="left" for="data_termino">Data término *</Label>
                                        <Input
                                            id="data_termino"
                                            label="Data fim *"
                                            className="form-control"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={props.relatorio.data_termino}
                                            onChange={handleChange('data_termino')}
                                        />
                                    </FormGroup>
                                </Col>
                                {(authActions.isPrefeitura() || authActions.isGestor()) &&
                                    <Col md={4} lg={4}>
                                        <FormGroup>
                                            <Label className="left" for="id_empresa">Empresa</Label>
                                            <Select
                                                classNamePrefix="select"
                                                className="form-control basic-single p-0 border-0"
                                                value={renderOptionsEmpresas().filter(function (option) {
                                                    return option.value == props.relatorio.id_empresa
                                                })}
                                                placeholder="Selecione..."
                                                onChange={handleSelectChange('id_empresa')}
                                                isSearchable
                                                id="id_empresa"
                                                name="id_empresa"
                                                options={renderOptionsEmpresas()}
                                            />
                                        </FormGroup>
                                    </Col>
                                }
                                {authActions.isPrefeitura() &&
                                    <Col md={4} lg={4}>
                                        <Label className="left" for="prefeitura">Prefeitura</Label>
                                        <Input
                                            id="prefeitura"
                                            label="Prefeitura"
                                            className="form-control"
                                            disabled
                                            value={props.authentication.user.Prefeitura.nome}
                                        />
                                    </Col>
                                }
                                {authActions.isInseminador() &&
                                    <Col md={4} lg={4}>
                                        <Label className="left" for="empresa">Empresa</Label>
                                        <Input
                                            id="empresa"
                                            label="empresa"
                                            className="form-control"
                                            disabled
                                            value={props.authentication.user.Empresa.nome}
                                        />
                                    </Col>
                                }
                                {(authActions.isInseminador() || authActions.isGestor()) &&
                                    <Col md={4} lg={4}>
                                        <FormGroup>
                                            <Label className="left" for="inscricao_prefeitura">Prefeitura *</Label>
                                            <Select
                                                classNamePrefix="select"
                                                className="form-control basic-single p-0 border-0"
                                                value={renderOptionsPrefeituras().filter(function (option) {
                                                    return option.value == props.relatorio.inscricao_prefeitura
                                                })}
                                                onChange={handleSelectChange('inscricao_prefeitura')}
                                                isSearchable
                                                placeholder="Selecione..."
                                                id="inscricao_prefeitura"
                                                name="inscricao_prefeitura"
                                                options={renderOptionsPrefeituras()}
                                            />
                                        </FormGroup>
                                    </Col>
                                }
                                {(authActions.isPrefeitura() || authActions.isGestor()) &&
                                    <Col md={4} lg={4}>
                                        <FormGroup>
                                            <Label className="left" for="id_inseminador">Inseminador</Label>
                                            <Select
                                                style={{ minWidth: '500px' }}
                                                className="form-control basic-single p-0 border-0"
                                                classNamePrefix="select"
                                                value={renderOptionsInseminador().filter(function (option) {
                                                    return option.value == props.relatorio.id_inseminador
                                                })}
                                                placeholder="Selecione..."
                                                onChange={handleSelectChange('id_inseminador')}
                                                isSearchable
                                                id="id_inseminador"
                                                name="id_inseminador"
                                                options={renderOptionsInseminador()}
                                            />
                                        </FormGroup>
                                    </Col>
                                }
                                {/*<Col md={4} lg={4}>*/}
                                {/*    <FormGroup>*/}
                                {/*        <Label className="left" for="id_produtor">Produtor</Label>*/}
                                {/*        <Select*/}
                                {/*            classNamePrefix="select"*/}
                                {/*            className="form-control basic-single p-0 border-0"*/}
                                {/*            value={renderOptionsProdutores().filter(function (option) {*/}
                                {/*                return option.value == props.relatorio.id_produtor*/}
                                {/*            })}*/}
                                {/*            onChange={handleSelectChange('id_produtor')}*/}
                                {/*            isSearchable*/}
                                {/*            id="id_produtor"*/}
                                {/*            name="id_produtor"*/}
                                {/*            options={renderOptionsProdutores()}*/}
                                {/*        />*/}
                                {/*    </FormGroup>*/}
                                {/*</Col>*/}
                                <Col md={12} lg={12} style={{ textAlign: 'right' }}>
                                    <Button variant="contained" className="mr-1" color="secondary" component='a' href="/">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                    <Button variant="contained" className="mr-1" color="success" onClick={(event) => handleGerarRelatorio(event)}>Gerar relatório <FontAwesomeIcon icon={faFile} /></Button>
                                    <Button variant="contained" className="mr-1" color="primary" type="submit">Gerar comprovantes <FontAwesomeIcon icon={faFilePdf} /></Button>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>

            
        </div>
    );
}

const mapStateToProps = (state) => {
    return state;
}

const connectedRelatorioFiltroPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(RelatorioFiltro));

export { connectedRelatorioFiltroPage as RelatorioFiltro };
